var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"timetable-session"},[(_vm.showAge)?_c('span',{staticClass:"age"},[_vm._v(_vm._s(_vm.age))]):_vm._e(),_c('span',{staticClass:"type"},[_vm._v(_vm._s(_vm.type))]),_c('span',{staticClass:"level"},[_vm._v(_vm._s(_vm.level))]),_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.start)+" - "+_vm._s(_vm.end))])])
}
var staticRenderFns = []

export { render, staticRenderFns }